
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 448 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"m296 432h16a8 8 0 0 0 8-8v-272a8 8 0 0 0 -8-8h-16a8 8 0 0 0 -8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8v-272a8 8 0 0 0 -8-8h-16a8 8 0 0 0 -8 8v272a8 8 0 0 0 8 8zm304-368h-104l-33.6-44.8a48 48 0 0 0 -38.4-19.2h-80a48 48 0 0 0 -38.4 19.2l-33.6 44.8h-104a8 8 0 0 0 -8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48v-368h24a8 8 0 0 0 8-8v-16a8 8 0 0 0 -8-8zm-268.8-25.6a16.1 16.1 0 0 1 12.8-6.4h80a16.1 16.1 0 0 1 12.8 6.4l19.2 25.6h-144zm212.8 425.6a16 16 0 0 1 -16 16h-288a16 16 0 0 1 -16-16v-368h320zm-168-32h16a8 8 0 0 0 8-8v-272a8 8 0 0 0 -8-8h-16a8 8 0 0 0 -8 8v272a8 8 0 0 0 8 8z"}})])
          )
        }
      }
    